import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Selectors, useAvailableOptIns, useOptIns } from '@grandvisionhq/auth';
import { useIntl, useSelector, useDispatch, useFeatureToggles } from '@grandvisionhq/state';
import { setChangedOptIns } from '../../../actions.js';
import { useCheckoutSettings } from '../../../context/CheckoutSettings/context.js';
import { getConsents, shouldCreateAccount } from '../../../selectors.js';
import { toggleConsent, setConsents } from '../../../StepShipping/actions.js';
import { ConsentsContainer } from '../containers/ConsentsContainer.js';
import { CreateAccountContainer } from '../containers/CreateAccountContainer.js';
import { OptInsContainer } from '../containers/OptInsContainer.js';
import { toSavedOptIns, getShownOptIns, toChangedOptIns } from '../utils/opt-ins.js';

const Consents = ({ handleOptInsLoading  })=>{
    const { getLabel  } = useIntl();
    const { consent: consentSettings , account  } = useCheckoutSettings();
    const consents = useSelector(getConsents);
    const dispatch = useDispatch();
    const isLoggedIn = useSelector(Selectors.isLoggedIn);
    const { availableOptIns  } = useAvailableOptIns();
    const { optInsFromServer , isFetching  } = useOptIns();
    const shouldCreateAccountBoolean = useSelector(shouldCreateAccount);
    const { isMyAccountEnabled  } = useFeatureToggles();
    // Consents
    const selectedConsents1 = React.useMemo(()=>{
        return consents === null || consents === void 0 ? void 0 : consents.filter((consent)=>consent.isChecked
        );
    }, [
        consents
    ]);
    const handleConsentChange = React.useCallback((selectedConsents)=>{
        dispatch(toggleConsent({
            consents: selectedConsents.map((consent)=>consent.value
            )
        }));
    }, [
        dispatch
    ]);
    React.useEffect(()=>{
        const checkoutConsents = (consentSettings === null || consentSettings === void 0 ? void 0 : consentSettings.items) || [];
        if (checkoutConsents.length !== (consents === null || consents === void 0 ? void 0 : consents.length)) {
            const initialConsents = checkoutConsents.map((consent)=>swcHelpers.objectSpread({}, consent, {
                    isChecked: false
                })
            );
            dispatch(setConsents({
                consents: initialConsents
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        consentSettings,
        consents
    ]);
    // Opt-ins
    const [selectedOptIns, setSelectedOptIns] = React.useState([]);
    const allOptIns = (consentSettings === null || consentSettings === void 0 ? void 0 : consentSettings.optIns) || availableOptIns.filter((item)=>item.isInSignup
    );
    const savedOptIns = React.useMemo(()=>toSavedOptIns(optInsFromServer)
    , [
        optInsFromServer
    ]);
    const shownOptIns = React.useMemo(()=>getShownOptIns(allOptIns, savedOptIns)
    , [
        allOptIns,
        savedOptIns
    ]);
    const handleOptInsChange = React.useCallback((selectedItems)=>{
        setSelectedOptIns(selectedItems);
        const changedOptIns = toChangedOptIns(allOptIns, savedOptIns, selectedItems, getLabel);
        // store ungrouped optins ready to be saved in the redux state
        dispatch(setChangedOptIns(changedOptIns));
    }, [
        dispatch,
        getLabel,
        allOptIns,
        savedOptIns
    ]);
    React.useEffect(()=>{
        /**
     *  Callback to notify the consumer of OptInsContainer
     *  about OptIns loading status from GQL query
     *  In checkout the user doesn't have to be logged in to proceed
     */ handleOptInsLoading === null || handleOptInsLoading === void 0 ? void 0 : handleOptInsLoading({
            isOptInsLoading: isFetching
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFetching
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "checkout__checkboxes"
    }, /*#__PURE__*/ React.createElement(CreateAccountContainer, null), /*#__PURE__*/ React.createElement(OptInsContainer, {
        optIns: shownOptIns,
        selectedOptIns: selectedOptIns,
        onChange: handleOptInsChange,
        isLoggedIn: isLoggedIn,
        shouldCreateAccountBoolean: shouldCreateAccountBoolean,
        implicitAccountCreation: account === null || account === void 0 ? void 0 : account.implicitAccountCreation,
        isMyAccountEnabled: isMyAccountEnabled
    }), /*#__PURE__*/ React.createElement(ConsentsContainer, {
        consents: consents,
        selectedConsents: selectedConsents1,
        onChange: handleConsentChange
    }));
};

export { Consents };
//# sourceMappingURL=Consents.js.map
